import { render, staticRenderFns } from "./PharmacistsRequests.vue?vue&type=template&id=476a39d1&scoped=true&"
import script from "./PharmacistsRequests.vue?vue&type=script&lang=js&"
export * from "./PharmacistsRequests.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistsRequests.vue?vue&type=style&index=0&id=476a39d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a39d1",
  null
  
)

export default component.exports